/* globals google */

import base from '~base';

import $ from 'jquery';
import { fetchOptionsGet, removeParamsFromURL, loadContent } from '../util/fetchutils'; // eslint-disable-line
import { appendToUrl, parseQueryString } from '../util/urlutils';
import {
  onEvent, getJSONData, isLG, // eslint-disable-line import/named
} from '../util/domutils';
import { replaceUrlParams } from '../../../../scripts/helpers/urlHelpers';
import { searchStores } from '../components/searchStores';
import tooltip from '../components/tooltip';

const SELECTORS = {
  SEARCH_STORE_BOX_ARROW: '.toggle-store-locator-container-left',
  STORE_INFO_BOX_ARROW: '.toggle-store-locator-container-right',
  STORE_LOCATOR_CONTAINER: '.store-locator-container',
  STORE_LOCATOR_CONTAINER_SEARCH: '.store-locator-container-search',
  STORE_LOCATOR_TABS_CONTAINER: '.store-locator-tabs-container',
  STORES_DETAILS_CONTAINER: '.stores-details-container',
  SEARCH_STORE_BOX_ARROW_LEFT_ARROW: '.toggle-store-locator-container-left .icon-chevron-left',
  SEARCH_STORE_BOX_ARROW_RIGHT_ARROW: '.toggle-store-locator-container-left .icon-chevron-right',
  STORE_INFO_BOX_ARROW_LEFT_ARROW: '.toggle-store-locator-container-right .icon-chevron-left',
  STORE_INFO_BOX_ARROW_RIGHT_ARROW: '.toggle-store-locator-container-right .icon-chevron-right',
  NAV_TAB: '.store-locator-tab',
  NAV_TAB_LIST: '.tab-list',
  NAV_TAB_MAP: '.tab-map',
  MAP_CANVAS: '.map-canvas',
  MAP_KEY: '.mobile-map-key',
  CLEAR_FILTERS: '.clear-filters',
  SEARCH_FORM: '.search-form',
  LOCATOR_FORM: 'form.store-locator',
  TOOLTIP_FILTER_CONTAINER: '.storelocator-arrow-tooltip-filter',
  TOOLTIP_SEARCH_RESULTS_CONTAINER: '.storelocator-arrow-tooltip-results',
};

// Reused DOM elements throughout different functions
const storesDetailsContainer = document.querySelector(SELECTORS.STORES_DETAILS_CONTAINER);
const storeInfoBoxArrow = document.querySelector(SELECTORS.STORE_INFO_BOX_ARROW);
const arrowLeft = document.querySelector(SELECTORS.STORE_INFO_BOX_ARROW_LEFT_ARROW);
const arrowRight = document.querySelector(SELECTORS.STORE_INFO_BOX_ARROW_RIGHT_ARROW);
const tabsContainer = document.querySelector(SELECTORS.STORE_LOCATOR_TABS_CONTAINER);

// Init UK Map in the center of the viewport
const STARTING_COORDINATES = {
  lat: 55.3617609,
  long: -3.4433238,
};

const MAP_OPTIONS_CONFIG = {
  scrollwheel: true,
  zoom: 6,
  mapTypeControl: false,
  streetViewControl: false,
};

// Add objects definitions inside the showPosition function to ensure that google is defined
const showPosition = () => {
  const isStoreDetails = () => !!document.querySelector('.store-details-page-container');

  const getImageConfig = url => ({
    src: url,
    scale: isStoreDetails() ? 2.5 : 1.1,
    anchor: new google.maps.Point(13, 30),
    labelOrigin: new google.maps.Point(12, 12),
  });

  const createMapOptions = (mapOptions, center) => {
    const options = {
      scrollwheel: mapOptions.scrollwheel,
      zoom: mapOptions.zoom,
      center,
      mapTypeControl: mapOptions.mapTypeControl,
      streetViewControl: mapOptions.streetViewControl,
    };

    if (isStoreDetails()) {
      options.draggable = false;
    }

    if (window.beesfra && window.beesfra.config && window.beesfra.config.customMapStyle) {
      options.styles = JSON.parse(window.beesfra.config.customMapStyle);
    }

    return options;
  };

  const createMarker = (storeLocation, map, item, markerImg) => {
    const markerOptions = {
      position: storeLocation,
      map,
      title: item.name,
      icon: markerImg,
    };

    const marker = new google.maps.Marker(markerOptions);

    return marker;
  };

  const createMarkerLink = (item) => {
    const link = document.createElement('a');
    link.innerHTML = item.name;
    link.href = item.storeUrl;
    link.target = '_blank';

    return link;
  };

  const createMarkerImg = img => ({
    url: img.src,
    scale: img.scale,
    anchor: img.anchor,
    labelOrigin: img.labelOrigin,
  });

  const mapWidgets = {
    map: null,
    infowindow: null,
    initialized: false,
    markers: [],
  };

  const initMapWidget = () => {
    if (!mapWidgets.initialized) {
      const mapCanvas = document.querySelector(SELECTORS.MAP_CANVAS);
      mapWidgets.infowindow = new google.maps.InfoWindow();
      // Init UK Map in the center of the viewport
      const latlng = new google.maps.LatLng(STARTING_COORDINATES.lat, STARTING_COORDINATES.long);

      const mapOptions = createMapOptions(MAP_OPTIONS_CONFIG, latlng);
      mapWidgets.map = new google.maps.Map(mapCanvas, mapOptions);
      mapWidgets.initialized = true;
    }
  };

  if (!mapWidgets.initialized) {
    initMapWidget();
  } else {
    mapWidgets.markers.forEach((marker) => {
      marker.setMap(null);
    });
  }

  const mapCanvas = document.querySelector(SELECTORS.MAP_CANVAS);

  const mapdiv = getJSONData(mapCanvas, 'locations', {});

  const bounds = new google.maps.LatLngBounds();

  Object.keys(mapdiv).forEach((key) => {
    const item = mapdiv[key];
    const imageConfig = getImageConfig(item.googleMapsMarkerIconUrl);
    const markerImg = createMarkerImg(imageConfig);
    const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
    const marker = createMarker(storeLocation, mapWidgets.map, item, markerImg);

    mapWidgets.markers.push(marker);

    marker.addListener('click', () => {
      mapWidgets.infowindow.setOptions({
        content: createMarkerLink(item),
      });
      mapWidgets.infowindow.open(mapWidgets.map, marker);
    });

    // Create a minimum bound based on a set of store locations
    bounds.extend(marker.position);
  });

  // Fit all the store marks in the center of a minimum bounds when any store has been found.
  if (mapdiv && mapdiv.length !== 0) {
    mapWidgets.map.fitBounds(bounds);
    const centerLatLong = new google.maps.LatLng(mapdiv[0].latitude, mapdiv[0].longitude);
    const listener = google.maps.event.addListener(mapWidgets.map, 'idle', () => {
      mapWidgets.map.setZoom(14);
      mapWidgets.map.setCenter(centerLatLong);

      google.maps.event.removeListener(listener);
    });
  }
};

const updateStoresResults = (data) => {
  const resultsDiv = document.querySelector('.results');
  const mapDiv = document.querySelector(SELECTORS.MAP_CANVAS);
  const hasResults = data.stores.length;

  if (!hasResults || hasResults === 0) {
    document.querySelector('.store-locator-no-results').classList.remove('d-none');
    document.querySelector('.store-locator-no-results').classList.add('d-block');
  } else {
    document.querySelector('.store-locator-no-results').classList.add('d-none');
    document.querySelector('.store-locator-no-results').classList.remove('d-block');
  }

  resultsDiv.innerHTML = '';

  resultsDiv.setAttribute('data-has-results', hasResults);
  // resultsDiv.setAttribute('data-radius', data.radius);
  resultsDiv.setAttribute('data-search-key', data.searchKey);

  mapDiv.setAttribute('data-locations', data.locations);

  if (mapDiv.getAttribute('data-has-google-api')) {
    showPosition();
  } else {
    document.querySelector('.store-locator-no-apiKey').classList.remove('d-none');
  }

  if (data.storesResultsHtml && data.stores.length) {
    resultsDiv.innerHTML = data.storesResultsHtml;
    document.querySelector('.store-locator .results .store-show-more').addEventListener('click', () => {
      const storeResults = document.querySelectorAll('.store-locator .results .card-body');
      storeResults.forEach((el) => {
        el.classList.remove('hidden-md-down');
      });
      document.querySelector('.store-locator .results .store-show-more').remove();
    });
  } else {
    resultsDiv.innerHTML = '';
  }

  const addressText = document.querySelector('#store-postal-code').value;
  if (addressText) {
    const nearText = document.querySelector('.search-near-text');
    if (nearText) {
      nearText.innerHTML = `"${addressText}"`;
    }
  }
};

const mobileScrollToResults = () => {
  if (!isLG()) {
    document.querySelector('.store-locator-tabs-container').scrollIntoView();
  }
};

const search = async (element) => {
  const storeLocatorForm = element.closest('.store-locator');

  const content = await searchStores(storeLocatorForm);
  updateStoresResults(content);
  mobileScrollToResults();
};

const searchByLocation = () => new Promise(((resolve) => {
  const postalCodeInput = document.querySelector('#store-postal-code');

  if (postalCodeInput) {
    document.querySelector('#store-postal-code').value = '';

    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(async (position) => {
      const mapCanvas = document.querySelector(SELECTORS.MAP_CANVAS);
      mapCanvas.dataset.locations = JSON.stringify([
        {
          infoWindowHtml: '',
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          name: 'My position',
        },
      ]);

      const storeLocatorForm = document.querySelector('.store-locator-container .store-locator');
      const coords = {
        lat: position.coords.latitude,
        long: position.coords.longitude,
      };
      const { content } = await loadContent(storeLocatorForm, null, coords);

      updateStoresResults(content);

      const updatedUrl = replaceUrlParams(storeLocatorForm.action, coords);
      storeLocatorForm.setAttribute('action', updatedUrl);

      resolve();
    }, (error) => {
      if (error.code === error.PERMISSION_DENIED) {
        // eslint-disable-next-line no-alert
        alert(window.beesfra.resources.storeLocator.errorLocationDisabled);
      }
    });
  }
}));

/**
 * Makes an ajax call that filters the stores based on the element that is passed
 * @param {*} element filtering element
 * @param {Boolean} noFilter if true no filtering is applied from the passed element
 * @param {Boolean} getFirstSearchResult adds onlyfirst parameter to url which then should return only the first store
 */
const filter = (element, noFilter, getFirstSearchResult) => {
  const storeLocatorForm = document.querySelector(SELECTORS.LOCATOR_FORM);
  let url = storeLocatorForm.getAttribute('action');
  let queryParam = element.getAttribute('name').replace('_brandFilter', '');
  const invertedStoreFilter = element.classList.contains('inverted-filter');
  if (invertedStoreFilter) {
    queryParam = queryParam.replace('_inverted', '');
  }

  let payload;
  url = removeParamsFromURL(url, [queryParam]);

  if (element.checked && !noFilter) {
    payload = {
      [queryParam]: !invertedStoreFilter,
    };
    url = appendToUrl(url, payload);
  }

  storeLocatorForm.setAttribute('action', url);

  if (getFirstSearchResult) {
    url = appendToUrl(url, {
      onlyfirst: true,
    });
  }

  storeLocatorForm.action = url;
  storeLocatorForm.dispatchEvent(new CustomEvent('submit', { bubbles: true, cancelable: true }));
};

const storeInfoOpen = () => {
  storesDetailsContainer.classList.remove('d-none');
  storeInfoBoxArrow.classList.remove('hide-right');
  arrowLeft.classList.add('d-none');
  arrowRight.classList.remove('d-none');
  tabsContainer.classList.remove('non-active');
};

const initTooltip = (tooltipContainer, tooltipContainerArrow, tooltipPlacement) => {
  const enableTooltip = !tooltipContainerArrow.classList.contains('d-none');

  if (enableTooltip) {
    tooltip(tooltipContainer, {
      placement: tooltipPlacement,
    });
  }
};

const initMap = () => {
  const mapCanvas = document.querySelector(SELECTORS.MAP_CANVAS);
  const resultsContainer = document.querySelector('.results');

  if (mapCanvas && document.querySelector(SELECTORS.MAP_CANVAS).hasAttribute('data-has-google-api')) {
    showPosition();
  } else {
    document.querySelector('.store-locator-no-apiKey').classList.add('d-block');
  }

  if (resultsContainer && !document.querySelector('.results').hasAttribute('data-has-results')) {
    document.querySelector('.store-locator-no-results').classList.add('d-block');
  }
};

base.showNearbyStores = async () => {
  if (!window.location.hash) {
    await searchByLocation();
    storeInfoOpen();
  }
};

base.init = () => {
  let googleMapsApiKeyScript = document.querySelector('script[src*="/maps/api/"]');

  if (googleMapsApiKeyScript) {
    initMap();
  } else {
    const scriptIntervalId = setInterval(() => {
      googleMapsApiKeyScript = document.querySelector('script[src*="/maps/api/"]');

      if (googleMapsApiKeyScript) {
        initMap();
        clearInterval(scriptIntervalId);
      }
    }, 500);
  }
};

base.detectLocation = () => {
  onEvent(document, 'click', '.detect-location', async (e) => {
    e.preventDefault();
    await searchByLocation();
    storeInfoOpen();
  });
};

base.search = () => {
  const searchContainer = document.querySelector(SELECTORS.STORE_LOCATOR_CONTAINER_SEARCH);
  onEvent(document, 'submit', '.store-locator-container form.store-locator', async (e) => {
    e.preventDefault();
    await search(e.delegateTarget);
    storeInfoOpen();
  });

  onEvent(document, 'click', '.store-locator-container .btn-storelocator-search[type="button"]', async (e) => {
    e.preventDefault();
    await search(e.delegateTarget);
    storeInfoOpen();
  });

  if (searchContainer) {
    searchContainer.addEventListener('keypress', (e) => {
      const searchButton = document.querySelector('.store-locator-container .btn-storelocator-search');

      // ASCII CR decimal code for Enter is 13
      if (e.keyCode === 13) {
        e.preventDefault();
        searchButton.click();
      }
    });
  }
};

base.filter = () => {
  onEvent(document, 'change', '#accordion-filter-stores input[type=checkbox]', (e) => {
    filter(e.delegateTarget);
  });
  onEvent(document, 'change', '.store-filter input[type=checkbox]', (e) => {
    const numberOfCheckedFilters = document.querySelectorAll('.store-filter input[type="checkbox"]:checked');

    if (numberOfCheckedFilters.length === 2) {
      filter(e.delegateTarget, true);
    } else if (numberOfCheckedFilters.length === 1) {
      filter(numberOfCheckedFilters[0]);
    } else {
      filter(e.delegateTarget, null, true);
    }
  });
};

base.initStoreSearchClose = () => {
  const storeLocatorContainer = document.querySelector(SELECTORS.STORE_LOCATOR_CONTAINER_SEARCH);
  const searchStoreBoxArrow = document.querySelector(SELECTORS.SEARCH_STORE_BOX_ARROW);
  const searchStoreArrowLeft = document.querySelector(SELECTORS.SEARCH_STORE_BOX_ARROW_LEFT_ARROW);
  const searchStoreArrowRight = document.querySelector(SELECTORS.SEARCH_STORE_BOX_ARROW_RIGHT_ARROW);

  onEvent(document, 'click', SELECTORS.SEARCH_STORE_BOX_ARROW, () => {
    storeLocatorContainer.classList.toggle('d-none');
    searchStoreBoxArrow.classList.toggle('hide-left');
    searchStoreArrowLeft.classList.toggle('d-none');
    searchStoreArrowRight.classList.toggle('d-none');
  });
};

base.initStoreInfoClose = () => {
  onEvent(document, 'click', SELECTORS.STORE_INFO_BOX_ARROW, () => {
    storesDetailsContainer.classList.toggle('d-none');
    storeInfoBoxArrow.classList.toggle('hide-right');
    arrowLeft.classList.toggle('d-none');
    arrowRight.classList.toggle('d-none');
  });
};

base.initMobileTabsListMap = () => {
  const storeLocatorTabsContainer = document.querySelector('.store-locator-tabs-container');
  const navTabList = document.querySelector(SELECTORS.NAV_TAB_LIST);
  const navTabMap = document.querySelector(SELECTORS.NAV_TAB_MAP);
  const mapCanvas = document.querySelector(SELECTORS.MAP_CANVAS);
  const mapKey = document.querySelector(SELECTORS.MAP_KEY);

  if (storeLocatorTabsContainer) {
    onEvent(storeLocatorTabsContainer, 'click', SELECTORS.NAV_TAB, () => {
      navTabList.classList.toggle('active-tab');
      navTabMap.classList.toggle('active-tab');
      mapCanvas.classList.toggle('d-none');
      mapKey.classList.toggle('d-none');
      storesDetailsContainer.classList.toggle('d-none');
    });
  }
};

base.clearFilters = () => {
  const searchForm = document.querySelector(SELECTORS.SEARCH_FORM);

  if (searchForm) {
    onEvent(searchForm, 'click', SELECTORS.CLEAR_FILTERS, () => {
      const checkboxes = searchForm.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          // Trigger click instead of checkbox.checked = false in order to fetch updated data again
          checkbox.click();
        }
      });
    });
  }
};

base.initializeTooltips = () => {
  const tooltipFilter = SELECTORS.TOOLTIP_FILTER_CONTAINER;
  const tooltipSearchResults = SELECTORS.TOOLTIP_SEARCH_RESULTS_CONTAINER;
  let tooltipContainerArrow;

  if (tooltipFilter) {
    onEvent(document, 'click', tooltipFilter, () => {
      tooltipContainerArrow = document.querySelector('.storelocator-arrow-tooltip-filter .icon-chevron-right');
      initTooltip(tooltipFilter, tooltipContainerArrow, 'right');
    });
  }

  if (tooltipSearchResults) {
    onEvent(document, 'click', tooltipSearchResults, () => {
      tooltipContainerArrow = document.querySelector('.storelocator-arrow-tooltip-results .icon-chevron-left');
      initTooltip(tooltipSearchResults, tooltipContainerArrow, 'left');
    });
  }
};

base.initSearchOnLoad = () => {
  const searchForm = document.querySelector(SELECTORS.LOCATOR_FORM);

  if (window.location.hash && window.location.hash.length && searchForm) {
    const nonInputParams = [];
    const hashParams = parseQueryString(window.location.hash);

    Object.keys(hashParams).forEach((param) => {
      const input = document.querySelector(`[name="${param}"]`);

      if (input) {
        if (hashParams[param] === 'true' || hashParams[param] === 'on') {
          const panel = input.closest('.collapse');

          input.checked = true;

          if (panel) {
            $(panel).collapse('show');
          }
        } else {
          input.checked = false;
        }

        if (typeof hashParams[param] === 'string') {
          input.value = hashParams[param];
        }
      } else {
        nonInputParams.push(param);
      }
    });

    if (nonInputParams.length) {
      const qsParts = nonInputParams.reduce((qs, param) => qs.concat(`${param}=${hashParams[param]}`), []);

      searchForm.action += `?${qsParts.join('&')}`;
    }

    searchForm.dispatchEvent(new CustomEvent('submit', { bubbles: true, cancelable: true }));
  }

  searchForm.addEventListener('submit', () => {
    setTimeout(() => {
      const searchFormFormData = new FormData(searchForm);

      window.location.hash = new URLSearchParams(searchFormFormData).toString();
    });
  });
};

base.enableSearchButton = () => {
  document.onreadystatechange = () => {
    if (document.readyState === 'complete'
    && (document.querySelector('.btn-storelocator-search')
    && document.querySelector('#store-postal-code'))) {
      if (document.querySelector('.btn-storelocator-search').hasAttribute('disabled')) {
        document.querySelector('.btn-storelocator-search').removeAttribute('disabled');
      }
      if (document.querySelector('#store-postal-code').hasAttribute('disabled')) {
        document.querySelector('#store-postal-code').removeAttribute('disabled');
      }
    }
  };
};

export default base;
